import { KnownAction } from "../actions/attendees.actions";
import { IAttendeesState } from "../models/attendees.interface";

const initialState: IAttendeesState = {
  selected: {
    attended: [],
    errors: [{ attended: undefined, attendee: undefined }],
  },
};

function eventReducer(
  state: IAttendeesState = initialState,
  action: KnownAction
): IAttendeesState {
  switch (action.type) {
    // Attendee
    case "SET_ATTENDEES": {
      return {
        ...state,
        data: action.data,
      };
    }
    case "SET_ATTENDEES_STATE": {
      return {
        ...state,
        data: action.data,
      };
    }
    case "SET_ATTENDEE_STATISTICS": {
      return {
        ...state,
        statistics: action.data,
      };
    }
    case "SHOW_ATTENDEE_INFO": {
      return {
        ...state,
        attendeeId: action.attendeeId,
      };
    }
    case "HIDE_ATTENDEE_INFO": {
      return {
        ...state,
        attendeeId: undefined,
      };
    }
    case "SET_ATTENDEE_INFO": {
      return {
        ...state,
        selected: {
          ...state.selected,
        },
      };
    }
    case "SET_EVENTS_FOR_ATTENDEE": {
      return {
        ...state,
        selected: {
          ...state.selected,
          attended: action.data,
        },
      };
    }
    case "SET_EVENTS_FOR_ATTENDEE_STATE": {
      return {
        ...state,
        selected: {
          ...state.selected,
          attended: action.data,
        },
      };
    }

    default:
      return state;
  }
}

export default eventReducer;
